export { HeaderProductV2 as HeaderCardSidescroll } from '../HeaderProductV2';
